import { Box } from '@material-ui/core';
import React from 'react';
import { translate } from '../../../../common/intl';
import { Button } from '../../../components/forms/fields-next';
import KendoDataGridShell, { KendoDataGridShellColumn } from '../../../components/KendoDataGrid/KendoDataGridShell';

interface PlaceholderProps {
  columns: KendoDataGridShellColumn[]
  canAdd?: boolean
  onAdd?: () => void
}

const Placeholder: React.FC<PlaceholderProps> = ({
  columns,
  canAdd,
  onAdd,
}) => (
  <Box data-cy="material-grid">
    <KendoDataGridShell
      columns={columns}
      withBottomButton={canAdd}
      dataCy="material-grid-empty"
    />
    {canAdd && (
      <Button kind="add" fullWidth attached onClick={onAdd} data-cy="add-material">
        {translate('form.builder.procedure.material.table.add.part')}
      </Button>
    )}
  </Box>
);

export default Placeholder;
